<template>
  <v-row class="editOptionsQuestionComponent">
    <v-col
      cols="12"
      sm="8"
    >
      <v-row>
        <v-col cols="12">
          <v-text-field
            v-model="questionCopy.question"
            :counter="500"
            :maxlength="500"
            :rules="[
              ...Rules.requiredNamed('Question'),
              ...Rules.max(questionCopy.question, 500)
            ]"
            label="Question text"
            required
          />
        </v-col>
        <v-col
          cols="12"
          sm="6"
        >
          <v-autocomplete
            v-model="questionCopy.question_type"
            :items="types"
            item-text="name"
            :rules="Rules.requiredNamed('Question type')"
            label="Question Type"
            return-object
            required
            @change="setItems()"
          />
        </v-col>
        <v-col
          cols="12"
          sm="6"
        >
          <v-combobox
            v-model="questionCopy.selectedRules"
            :items="items"
            label="Validation Rules"
            multiple
            chips
            attach
          />
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="12">
          <v-switch
            v-model="includeDocuments"
            label="Include Document(s)"
          />
          <QuestionDocumentsEditComponent
            v-if="includeDocuments"
            :documents="questionCopy.question_documents"
            @newDocument="updateDocuments($event)"
          />
        </v-col>
      </v-row>
    </v-col>
    <v-col
      cols="12"
      sm="4"
    >
      <QuestionOptionsComponent
        :options="questionCopy.question_options"
        @newOption="updateOptions($event)"
      />
    </v-col>
  </v-row>
</template>
<script>
export default {
  name: 'EditOptionsQuestionComponent',
  props: {
    question: {
      type: Object,
      default: () => {
        return {}
      }
    },
    types: {
      type: Array,
      default: () => {
        return {}
      }
    }
  },
  data: () => ({
    questionCopy: {},
    includeDocuments: false
  }),
  computed: {
    items () {
      return this.setItems()
    }
  },
  watch: {
    question (newQuestion, oldQuestion) {
      this.questionCopy = newQuestion
      this.setItems()
    }
  },
  created () {
    this.questionCopy = this.question
    this.questionCopy.selectedRules = this.question.rules ? this.question.rules : []
    this.setItems()
  },
  methods: {
    updateDocuments (documents) {
      this.questionCopy.question_documents = documents
    },
    updateOptions (options) {
      this.questionCopy.question_options = options
    },
    setItems () {
      return this.question.question_type.type === 'dropdown' ? [
        'required'
      ] : this.question.question_type.type === 'checkboxes' ? [
        'required',
        'accepted'
      ] : [
        'required',
        'multiple'
      ]
    }
  }
}
</script>
<style lang="scss">
.editOptionsQuestionComponent {
  //
}
</style>
